import { render, staticRenderFns } from "./appraisal.vue?vue&type=template&id=2398498d&scoped=true"
import script from "./appraisal.vue?vue&type=script&lang=js"
export * from "./appraisal.vue?vue&type=script&lang=js"
import style0 from "./appraisal.vue?vue&type=style&index=0&id=2398498d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2398498d",
  null
  
)

export default component.exports